<button
  mat-icon-button
  class="server-status-indicator"
  [ngClass]="statusClass"
  [matTooltip]="tooltip"
  matTooltipPosition="below"
  (click)="onClick()"
  [attr.aria-label]="'SERVER_STATUS.TITLE' | translate">

  <!-- Loading spinner -->
  @if (isLoading) {
    <mat-spinner
      diameter="20"
      class="status-spinner">
    </mat-spinner>
  }

  <!-- Status icon -->
  @if (!isLoading) {
    <mat-icon>{{ statusIcon }}</mat-icon>
  }

</button>
